<template>
    <Field
            :labelFor="name"
            :title="title"
            :errorMessage="errorMessage"
            :description="description"
            :required="required"
            :helpText="helpText"
    >

        <template v-slot:input>
            <input
                    :name="name"
                    :id="name"
                    :disabled="disabled"
                    :type="type"
                    :value="value"
                    :maxlength="maxLength"
                    class="form__control"
                    v-model="model"
            />
        </template>
    </Field>
</template>

<script>
    import FieldMixin from '../../mixins/FieldMixin'

    export default {
        name: 'FieldText',
        mixins: [
            FieldMixin
        ],
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldText.vue